import { apolloClient } from "../../vue-apollo";
import {
} from "../../graphql/queries";
import {
  DAR_LIKE,
  QUITAR_LIKE,
} from "../../graphql/mutations";

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {

  },
  actions: {
    async darLikeAction(_, data_) {
      const params = {
        mutation: DAR_LIKE,
        variables: data_
      }
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        // console.log(res)
        if (!res.loading) response = res.data.agregarLikesEmpresa;
      } catch (e) {
        console.log("Falla metodo darLikeAction: ", e);
      }
      return response;
    },

    async quitarLikeAction(_, data_) {
      const params = {
        mutation: QUITAR_LIKE,
        variables: data_
      }
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.eliminarLikeEmpresa;
      } catch (e) {
        console.log("Falla metodo quitarLikeAction: ", e);
      }
      return response;
    }


  }
};